import { setSetting, settings, whatToShow } from '../state';
import { Sheet, Toggle } from './chrome';

// The sky starts clean; people switch on what they want to see. Asked in the welcome, and once for an
// install from before the sky started clean. The same things are in Layers.

export function WhatToShowToggles() {
  const s = settings.value;
  return (
    <div class="group what-to-show">
      <Toggle on={s.constellationLines && s.constellationNames} onChange={(v) => { setSetting('constellationLines', v); setSetting('constellationNames', v); }} icon="star" label="Constellations" sub="Their lines and names" />
      <Toggle on={s.starNames} onChange={(v) => setSetting('starNames', v)} icon="sparkle" label="Star names" sub="The names of the brighter stars" />
      <Toggle on={s.satellites !== 'off'} onChange={(v) => setSetting('satellites', v ? 'bright' : 'off')} icon="satellite" label="Satellites and space stations" sub="The ISS and bright satellites as they pass" />
      <Toggle on={s.meteors} onChange={(v) => setSetting('meteors', v)} icon="meteor" label="Shooting stars" sub="Meteor showers and where they seem to come from" />
      <Toggle on={s.deepSky} onChange={(v) => setSetting('deepSky', v)} icon="eye" label="Galaxies, clusters and nebulae" sub="The best-known ones, as you zoom in" />
    </div>
  );
}

/** Once, for an install from before the sky started clean. */
export function WhatToShowSheet() {
  const done = () => (whatToShow.value = false);
  return (
    <Sheet onClose={done} size="tall" label="What would you like to see?">
      <h2 class="sheet-title">What would you like to see?</h2>
      <p class="row-sub pad-x">The stars, the planets and the Moon are always there. Switch on anything else you would like. You can change these any time in Sky view.</p>
      <WhatToShowToggles />
      <div class="pad-x">
        <button class="btn" onClick={done}>Done</button>
      </div>
    </Sheet>
  );
}
